<template>
<el-row>
  <el-col :span="2"></el-col>


  <el-col :span="20">
    <div class="mainDiv">
      <h1>THE BORING COIN</h1>
      <br>
      <p>No twitter, no telegram, no bots! This website is just for you mfers to find the contract</p>
      <h2 class="contractAddress">0x1D40C595A4bbc290794f416Bf7C67d55f4bA8ffe</h2>
      <br><br><br>
      <label>Enter Code:</label>
      <input @change="showError = false" v-model="codeEntered" id="codeBox" @submit="checkCode()" type="text">
      <h4 v-if="showError" style="color:red;">Wrong Code</h4>
      <br><br>
      <img @click="read('NO TWITTER')" class="socials" src="../assets/twitter.webp" alt="">
      <img @click="read('NO TELEGRAM')" class="socials" src="../assets/telegram.webp" alt="">
      <br><br>
      <button @click="generateRandomPhrase()">BORING BUTTON</button>
      <p id="randomText"></p>
    </div>



    <el-dialog v-model="showModal" width="50%">
      <h2 style="color:green">CODE CONFIRMED<br><br> Welcome to Boring ( where there is absolutely no fun or excitement, just boring shit )<br>More boringness will be revealed</h2>
      <br>
      <h3>enter your wallet address</h3>
      <input type="text" style="width: 35%" id="walletBox" v-model="walletAddress">
      <button @click="submitWallet()">submit wallet</button>
    </el-dialog>
  </el-col>


  <el-col :span="2"></el-col>
</el-row>

</template> 

<script>
import axios from 'axios';

export default {
  data()
  {
    return{
      showError: false,
      codeEntered: "",
      showModal: false,
      walletAddress: "",
      ethAddressRegex: /^0x[a-fA-F0-9]{40}$/g,
      timeleft: 0,
      phrases:[
        "I'm too bored to do anything, try again",
        "You bought pepe and didn't sell, that's boring",
        "Stop clicking me you boring fuck",
        "Crypto is not just boring right now... It's embarrasing",
        "Staring at your meme coin portfolio is putting me to sleep 😴",
        "Boredom made me buy meme coins. Now they're worth nothing, and I'm still bored",
        "Watching Shiba Inu Coin's chart is as exciting as watching paint dry",
        "I've seen more action in a sloth sanctuary than in the crypto market",
        "Too bored to count my Dogecoins. Maybe tomorrow.", "Ethereum's price movements? About as exciting as watching grass grow.", "Got so bored, I bought into a rug pull.", "My ledger wallet just yawned.", "When crypto crashes, I just get more bored.", "Tried to explain Bitcoin to my grandma... we both dozed off.", "Crypto winter is like an endless, dull movie.", "Bored? Try reading the latest ICO whitepaper.", "Decentralized finance is currently as thrilling as a tax seminar.", "Fiat money looks so boring after crypto, but at least it's stable.", "Missed the SafeMoon pump because I fell asleep at my computer.", "NFTs: Now For Tedium.", "I'd rather watch a tortoise race than this Bitcoin dip.", "If crypto were a TV show, I'd change the channel.", "I got so bored, I mined a block by hand.", "My altcoins are as stagnant as pond water.", "Watching the Litecoin chart is a surefire cure for insomnia.", "Tried day trading, but the charts just put me to sleep.", "Even the crypto influencers are yawning.", "Just sold my boredom at a major loss.", "Do you know what's less exciting than a bear market? Nothing.", "My proof of stake? More like proof of yawn.", "Watching Ethereum gas fees is as interesting as a traffic jam.", "Stared at my Binance account so long, I saw tumbleweeds.", "My DeFi yield farming has yielded mostly yawns.", "I bought Ripple at its peak. Now it's boring and broke.", "Crypto markets: Now slower than a sloth race.", "This ICO is more snooze than news.", "My staking rewards came in. Snore.", "I'm so bored, even the crypto bots stopped replying.", "Margin trading or watching paint peel? I choose the latter.", "Just made a smart contract to manage my yawning.", "Tried to get excited about the latest airdrop. Fell asleep instead.", "Crypto volatility: From thrilling highs to snooze-inducing lows.", "Mining Bitcoin is about as exciting as watching a dial-up modem connect.", "I miss when crypto was fun. Now it's just ledger entries and boredom.", "Tried to diversify my portfolio. Ended up diversifying my yawns instead.", "My excitement over this altcoin pump is about as real as a Tether audit.", "Watching the DeFi space is like staring at a chess board.", "If I had a Satoshi for every time crypto bored me, I'd be a billionaire.", "Crypto is so boring right now, I'd rather sort socks.", "Uniswap is currently as riveting as a turtle knitting.", "Got bored, bought some SHIB, now I'm bored and broke.", "My cold storage is also emotionally cold.", "Proof-of-work or proof-of-sleep?", "Blockchains: Providing boredom one block at a time.", "My crypto strategy? Buy, HODL, yawn, repeat."
      ]
    }
  },
  beforeMount()
  {
    var countDownDate = new Date(1686718800 * 1000).getTime();
    var now = new Date().getTime();
    this.timeleft = countDownDate - now;
  },
  mounted()
  {
    const node = document.getElementById("codeBox");
    node.addEventListener("keyup", ({key}) => {
        if (key === "Enter") {
          this.checkCode()
        }
    })
    axios.get('https://boringapi.up.railway.app/api/contacts')
      .then(res=> {
        console.log(res.data.data.length)
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  methods:{
    async checkCode()
    {
      await axios.post('https://boringapi.up.railway.app/verify', {
        code: this.codeEntered,
      })
      .then(res=> {
        if(res.data.verification)
        {
          this.showModal = true;
        }
        else
        {
          this.showError = true;
        }
      })
      .catch(function (error) {
        console.log(error);
      });
    },
    async submitWallet()
    {
      if(!this.walletAddress.match(this.ethAddressRegex))
      {
        alert("invalid eth address")
        return;
      }

      var inDatabase = false;
      await axios.get('https://boringapi.up.railway.app/api/contacts')
      .then(res=> {
        for(var i=0; i<res.data.data.length; i++)
        {
          if(res.data.data[i].walletAddress === this.walletAddress)
          {
            inDatabase = true;
            break;
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });


      if(!inDatabase)
      {
        await axios.post('https://boringapi.up.railway.app/api/contacts', {
          walletAddress: this.walletAddress,
        })
        .then(res=> {
          console.log(res)
          alert("Successfully entered Boring!")
          this.showModal = false;
        })
        .catch(function (error) {
          console.log(error);
        });
      }
      else
      {
        alert("You are already in Boring")
        this.showModal = false;
      }
    },
    generateRandomPhrase()
    {
      document.getElementById("randomText").innerText = this.phrases[Math.floor(Math.random() * this.phrases.length)]
    },
    read(msg)
    {
      alert(msg)
    }
  }
}
</script>

<style>
a
{
  margin-right: 0.5vh;
  margin-left: 0.5vh;
}
.socials
{
  margin-right: 0.5vh;
  margin-left: 0.5vh;
  cursor: pointer;
}
.contractAddress
{
  font-size: 3vw;
}
h1
{
  font-size: 5vw;
}
.mainDiv
{
  border: 4px solid black;
  margin-top: 15vh;
  width: 100%;
}
.bot
{
  width: 80px
}
</style>